import { omit, pick } from "lodash";
import { ExportFilterGroups } from "PFApp/analytics/types/export_analytics";
import { Filters } from "PFTypes";
import { useMemo } from "react";

import { useDefaultPeriod } from "./use_default_period";

type UseFilterGroups = {
  entries: ExportFilterGroups | undefined;
};

type UseFilterGroupsReturn = {
  ungroupedFilters: Filters;
  filterGroups: ExportFilterGroups;
};

export const STANDARD_FILTERS_NAME = "standard_fields";

export const useFilterGroups = ({ entries }: UseFilterGroups): UseFilterGroupsReturn => {
  useDefaultPeriod({ entries });

  return useMemo<UseFilterGroupsReturn>(() => {
    if (!entries) {
      return { ungroupedFilters: {}, filterGroups: {} };
    }
    const filterGroups = omit(entries, [STANDARD_FILTERS_NAME]);
    const ungroupedFilters = pick(entries, [STANDARD_FILTERS_NAME]);

    return {
      ungroupedFilters: ungroupedFilters[STANDARD_FILTERS_NAME] || {},
      filterGroups
    };
  }, [entries]);
};
